import React from 'react';
import PropTypes from 'prop-types';
import {Controller} from "react-hook-form";
import FieldWithValidation from "../../../generic/fields/FieldWithValidation";
import { trimOnChange } from '../../../../lib/utils/helper'
import {t} from "i18next";

const Url = ({form, state, setState, stateKey = "url", isRequired = true, label, hint, isTrimOnChange, rules = {}, isWebValidate = false, placeholder = 'strogino'}) => {
    const {control, errors} = form;
    const URL_REGEX = /^https?:\/\/[^\s/$.?#].[^\s]*$/;
    const validateUrl = (value) => {
        if (!value) return true;

        if (isWebValidate) {
            const hasInvalidChars = /[#?&]/.test(value);
            return !hasInvalidChars || t('inputs.validation.invalidSilavetraUrl');
        }
        if (stateKey === "url") {
            return !value.includes('/') && (rules.validate ? rules.validate(value) : true)
        }
        return URL_REGEX.test(value)
    }
    const constRules = {validate: validateUrl}
    
    return (
        <Controller
            control={control}
            name={stateKey}
            defaultValue={state[stateKey] || ''}
            rules={
                stateKey === "url" || isRequired
                ? { required: t('inputs.validation.required'), ...rules, ...constRules }
                : { ...rules, ...constRules }}
            render={(
                {value, onBlur, name, ref, onChange},
                {invalid}
            ) =>
                <FieldWithValidation invalid={invalid} errors={errors} label={label}
                                     name={name} isRequired={isRequired}
                                     type="text" value={value} placeholder={placeholder}
                                     hint={hint}
                                     onBlur={e => {
                                         const newValue = e.target.value.replace(/\/+$/, '')
                                         onChange(newValue)
                                         setState({
                                             target: {
                                                 name: e.target.name,
                                                 value: newValue
                                             }
                                         })

                                         onBlur()
                                     }}
                                     onChange={e => {
                                        isTrimOnChange && trimOnChange(e)
                                        setState(e)
                                        onChange(e.target.value)
                                     }}
                />
            }
        />
    );
}

Url.propTypes = {
    form: PropTypes.object.isRequired,
    state: PropTypes.object.isRequired,
    setState: PropTypes.func.isRequired,
    stateKey: PropTypes.string, 
    isRequired: PropTypes.bool,
    label: PropTypes.string,
    hint: PropTypes.string,
    isTrimOnChange: PropTypes.bool,
};
export default Url;